module.exports = __webpack_public_path__ + "static/media/frost.852eea7b.pdf";